<!--
 * @Author: yannis yannis2473@163.com
 * @Date: 2025-04-14 15:20:21
 * @LastEditors: yannis yannis2473@163.com
 * @LastEditTime: 2025-04-15 15:33:05
 * @FilePath: \crm-admin-vue\src\components\NewCom\WkForm\WkFormItems.vue
 * @Description: Do not edit
 * Copyright (c) 2025 by 久雀商业/Yannis, All Rights Reserved. 
-->
<template>
  <flexbox class="wk-form-items" align="flex-start" wrap="wrap" justify="flex-start">
    <template v-for="(item, index) in fieldList" >
      <wk-form-item
        :key="index"
        :prop-prefix="propPrefix"
        :item="item"
        :index="index"
        :field-from="fieldFrom"
        :ignore-fields="ignoreFields"
        :disabled="disabled"
        @change="fieldChange">
        <template slot-scope="{ data, index }">
          <slot :data="item" :index="index" />
        </template>
      </wk-form-item>
    </template>
  </flexbox>
</template>

<script>
  import WkFormItem from "./WkFormItem";

  export default {
    // 多块形式的form-item 用于字段库
    name: "WkFormItems",

    components: {
      WkFormItem,
    },

    props: {
      // 表单验证前缀
      propPrefix: {
        type: String,
        default: "",
      },
      fieldFrom: {
        type: Object,
        default: () => {
          return {};
        },
      },
      fieldList: {
        type: Array,
        default: () => {
          return [];
        },
      },
      // 忽略的字段直接输出
      ignoreFields: {
        type: Array,
        default: () => {
          return [];
        },
      },
      disabled: Boolean,
    },

    data() {
      return {};
    },

    computed: {},

    watch: {},

    created() {},

    mounted() {},

    beforeDestroy() {},

    methods: {
      fieldChange(item, index, value, valueList) {
        this.$emit("change", item, index, value, valueList);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @media screen and(max-width: 768px) {
    .wk-form-items {
      display: flex !important;
      flex-flow: column nowrap;
      justify-content: flex-start;
      align-items: flex-start;
      .el-form-item {
        width: 100% !important;
      }
    }
  }
  @media screen and(min-width: 769px) {
    .wk-form-items {
      padding: 0 12px;
    }
  }
</style>
